var toggleLi, toggleBtn;

function initialize(){
    toggleLi = document.querySelector('.toggle');
    toggleBtn = toggleLi.getElementsByTagName('button')[0];

    document.querySelectorAll('.item').forEach( function (item){item.addEventListener('click', closeMenuOnMenuItemClick, false); })

    toggleLi.addEventListener('click', toggleMenu, false);

    console.log(toggleLi);
}

function toggleMenu(){
  var ico = toggleBtn.getElementsByTagName('i')[0];
  var span = toggleBtn.getElementsByTagName('span')[0]
    if(document.querySelectorAll('.active').length > 0){
      document.querySelectorAll('.active').forEach( function(item){ item.classList.remove('active'); });
      ico.classList.remove('ico-cross');
      ico.classList.add('ico-menu');
      span.textContent = 'Menü öffnen'
    }else{
      document.querySelectorAll('.item').forEach( function(item){ item.classList.add('active'); });
      ico.classList.remove('ico-menu');
      ico.classList.add('ico-cross');
      span.textContent = 'Menü schließen'
    }
     
}

function closeMenuOnMenuItemClick(){
  toggleLi.click();
}

export default {
  init: function() { initialize() }  
}


// WEBPACK FOOTER //
// ./src/shared/navigationHelper.js